import i18n from 'i18n-js';
import { DurationInputArg2 } from 'moment';
import { localTime } from '@helpers';

export const dateFormat = ({ date, selectedTime, showAverage }: { date?: string; selectedTime: DurationInputArg2; showAverage: boolean }) => {
  switch (selectedTime) {
    case 'year': {
      const formattedDate = `${localTime(date).format('YYYY')}`;
      return showAverage ? `${i18n.t('Average in')} ${formattedDate}` : formattedDate;
    }
    case 'month': {
      const formattedDate = `${i18n.t(localTime(date).format('MMMM'))}`;
      return showAverage ? `${i18n.t('Average in')} ${i18n.t(formattedDate)}` : formattedDate;
    }
    case 'week': {
      const formattedDate = `${i18n.t('Week')} ${localTime(date).isoWeek()}`;
      return showAverage ? `${i18n.t('Average in')} ${formattedDate}` : formattedDate;
    }
    case 'day': {
      const isToday = localTime(date).isSame(localTime().startOf('day'), 'd');
      if (isToday) {
        return showAverage ? i18n.t('Average for today') : i18n.t('Today');
      }
      const formattedDate = `${i18n.t(localTime(date).format('MMM'))} ${localTime(date).format('DD')}`;
      return showAverage ? `${i18n.t('Average on')} ${formattedDate}` : formattedDate;
    }
    default:
      const formattedDate = `${localTime(date).format('YYYY-MM-DD')}`;
      return showAverage ? `${i18n.t('Average on')} ${formattedDate}` : formattedDate;
  }
};
